import { render } from "./CreateShipmentView.vue?vue&type=template&id=5ddad6bf"
import script from "./CreateShipmentView.vue?vue&type=script&lang=js"
export * from "./CreateShipmentView.vue?vue&type=script&lang=js"

import "./CreateShipmentView.vue?vue&type=style&index=0&id=5ddad6bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__